import React from "react";
import { LoadingSpinner } from "shared/LoadingSpinner/LoadingSpinner";

type WaiterPopupProps = {
  open: boolean;
};

export const WaiterPopup: React.FC<WaiterPopupProps> = ({ open }) => {
  if (!open) return null;

  return (
    <div
      style={{
        position: "absolute",   // relative to parent container
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(0, 0, 0, 0.4)", // semi-transparent
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 10,
      }}
    >
      {/* <WaiterAnimation /> */}
      <LoadingSpinner size="large"/>
    </div>
  );
};